import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';
import { ReactNode } from 'react';
import LangEnum from '../../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../../translation/TranslationContext';

interface CatalogViewSettingsRowProps {
  label: LangEnum;
  children: ReactNode;
}

const CatalogViewSettingsRow = ({ label, children }: CatalogViewSettingsRowProps) => {
  const { translate } = useTranslation();

  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
      <Typography variant="body2" color="text.secondary">
        {translate(label)}
      </Typography>
      {children}
    </Stack>
  );
};

export default CatalogViewSettingsRow;
